module.exports = __webpack_public_path__ + "img/06_sub_uk.7736e9e5.svg";